import { CardZipCodeField } from '@anm/components/form/fields';
import { ValidationErrors } from 'final-form';
import values from 'lodash/fp/values';
import { FC } from 'react';

import { CardZipCodeFieldWrapper } from '../EditCardBlock/Wrapper';
import SecurePurchaseBlock from '../SecurePurchaseBlock';
import SubscriptionTitle from '../SubscriptionTitle';
import UpgradeBlockAlert from '../UpgradeBlockAlert';

import {
  EditCardFormRowItem,
  EditCardWrapper,
  SubmitEditCardBlockWrapper
} from './Wrapper';

export type SubmitEditCardBlockProps = {
  sslId: string;
  children: string;
  formErrors: ValidationErrors;
  isSubmitPending: boolean;
  onSubmit: () => void;
  errors?: string[];
};

const SubmitEditCardBlock: FC<SubmitEditCardBlockProps> = ({
  sslId,
  errors = [],
  children,
  formErrors,
  isSubmitPending,
  onSubmit
}) => {
  return (
    <>
      <SubmitEditCardBlockWrapper>
        <SubscriptionTitle>{children}</SubscriptionTitle>
        <EditCardWrapper />
        <EditCardFormRowItem>
          <CardZipCodeFieldWrapper>
            <CardZipCodeField
              inputVariant="simple-small"
              labelVariant="static-above-dark-uppercase"
            />
          </CardZipCodeFieldWrapper>
        </EditCardFormRowItem>
        <UpgradeBlockAlert
          errors={[...values(formErrors), ...errors].filter(Boolean)}
        />
      </SubmitEditCardBlockWrapper>
      <SecurePurchaseBlock
        {...{ sslId }}
        isPending={isSubmitPending}
        onPurchase={onSubmit}
      >
        {children}
      </SecurePurchaseBlock>
    </>
  );
};
export default SubmitEditCardBlock;
